export const updateLocalStorageFromQueryParams = (
    params: URLSearchParams,
    keys: string[]
): void => {
    keys.forEach((key) => {
        if (params.has(key)) {
            localStorage.setItem(key, 'true');
        } else {
            localStorage.removeItem(key);
        }
    });

    const eventId = params.get('eventId');
    if (eventId) {
        localStorage.setItem('eventId', eventId);
    }
};

export const buildQueryParamsFromStorage = (keys: string[]): string => {
    const params = new URLSearchParams();

    keys.forEach((key) => {
        const value = localStorage.getItem(key);
        if (value) {
            params.set(key, value === 'true' ? 'true' : value);
        }
    });

    return params.toString();
};
